/* eslint-disable react/prop-types, react/jsx-first-prop-new-line, react/jsx-closing-bracket-location */
import React from 'react';
import { t } from 'es6/services/localization';
import { StyleSheet, css } from 'aphrodite';
import Immutable from 'immutable';
import assetPath from 'es6/services/asset-path';
import RoundBox from 'es6/components/layout/round-box';
import Row from 'es6/components/layout/row';
import Column from 'es6/components/layout/column';

import { ERROR_DECORATOR_TITLE_COLOR } from 'es6/core/styles/colors';

export const ERROR_PAGE_PARAMS = Object.freeze({
  uploadLimit: '5MB',
});

export const ERROR_400_BAD_REQUEST_HTML =
  t('error-pages.400-bad-request-html', ERROR_PAGE_PARAMS);
export const ERROR_403_UNAUTHRORIZED_HTML =
  t('error-pages.403-unauthorized-html', ERROR_PAGE_PARAMS);
export const ERROR_404_NOT_FOUND_HTML =
  t('error-pages.404-not-found-html', ERROR_PAGE_PARAMS);
export const ERROR_405_WRONG_METHOD_HTML =
  t('error-pages.405-wrong-method-html', ERROR_PAGE_PARAMS);
export const ERROR_409_CONFLICT_HTML =
  t('error-pages.409-conflict-html', ERROR_PAGE_PARAMS);
export const ERROR_413_UPLOAD_OVERSIZED_HTML =
  t('error-pages.413-upload-oversized-html', ERROR_PAGE_PARAMS);
export const ERROR_422_UNPROCESSABLE_HTML =
  t('error-pages.422-unprocessable-html', ERROR_PAGE_PARAMS);
export const ERROR_500_SERVER_ERROR_HTML =
  t('error-pages.500-server-error-hml', ERROR_PAGE_PARAMS);
export const ERROR_502_BAD_GATEWAY_HTML =
  t('error-pages.502-bad-gateway-html', ERROR_PAGE_PARAMS);
export const ERROR_503_UNAVAILABLE_HTML =
  t('error-pages.503-unavailable-html', ERROR_PAGE_PARAMS);

export const ERROR_HTML_MAPPING = Immutable.Map([
  [400, ERROR_400_BAD_REQUEST_HTML],
  [403, ERROR_403_UNAUTHRORIZED_HTML],
  [404, ERROR_404_NOT_FOUND_HTML],
  [405, ERROR_405_WRONG_METHOD_HTML],
  [409, ERROR_409_CONFLICT_HTML],
  [413, ERROR_413_UPLOAD_OVERSIZED_HTML],
  [422, ERROR_422_UNPROCESSABLE_HTML],
  [500, ERROR_500_SERVER_ERROR_HTML],
  [502, ERROR_502_BAD_GATEWAY_HTML],
  [503, ERROR_503_UNAVAILABLE_HTML],
]);

function htmlForError(code) {
  return ERROR_HTML_MAPPING.get(code) ||
         // Show 400 for any other 4xx and 500 for any 5xx
         ERROR_HTML_MAPPING.get(Math.floor(code / 100) * 100) ||
         ERROR_500_SERVER_ERROR_HTML;
}


export function decorateWithErrorPage(ActualPage) {
  return (props) => (
    <ErrorDecorator error={props.error}>
      <ActualPage {...props} />
    </ErrorDecorator>
  );
}

export default function ErrorDecorator({ error, children }) {
  return error ? (
    <Row>
      <Column span={12}>
        <RoundBox>
          <div className={css(styles.page)}
            dangerouslySetInnerHTML={{ __html: addClasses(htmlForError(error.code)) }} />
        </RoundBox>
      </Column>
    </Row>
  ) : children;
}

const styles = StyleSheet.create({
  page: {
    minHeight: '280px',
    padding: '60px 70px 30px',
    backgroundImage: `url('${assetPath('common/owl_notfound.svg')}')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 50px bottom 30px',
  },
  h2: {
    fontSize: '55px',
    lineHeight: '1em',
    color: ERROR_DECORATOR_TITLE_COLOR,
    marginBottom: '20px',
  },
  h3: {
    fontSize: '18px',
    lineHeight: '32px',
    marginBottom: '20px',
  },
  p: {
    fontSize: '14px',
    lineHeight: '26px',
    maxWidth: '380px',
  },
});

function addClasses(html) {
  return html.replace(/<([a-z0-9]+)/g, (whole, part) => `<${part} class="${css(styles[part])}"`);
}
